import React, {FC} from 'react';
import {ProductDetail, ProductSize} from "../types/types";
import {Button} from '../components/Button';
import {useHistory} from "react-router-dom";
import {Icon} from "./Icon";
// import ShirtGuide from '../assets/img/shirt-guide.png';

interface LoginPopUpProps {
    open: boolean;
    nonMemberOrder: () => void;
    memberLogin: () => void;
    onClose: () => void;
}

export const LoginPopUp: FC<LoginPopUpProps> = ({open, nonMemberOrder, memberLogin, onClose}) => {
    if (!open) return <></>;
    return (
        <>
            <div data-aos="fade-in" data-aos-delay="900"
                className={`z-20 bg_3e52bb fixed md:right-4 md:top-18 md:w-3/12 top-18 flex p-4 space-x-4 w-11/12`}
            >
                <div className="text-white w-full">
                    <div className="flex justify-between">
                        <p className="">로그인이 되어있지않습니다.</p>
                        <button
                            onClick={onClose}
                            className="bg-gray-100 rounded-full wh-6 grid place-content-center"
                        >
                            <Icon.X/>
                        </button>
                    </div>

                    <div className="flex justify-between pt-3 pb-3">
                        <p className="">로그인 후 구매하시겠습니까?</p>
                    </div>
                    <div className="flex mt-2">
                        <Button
                            text="비회원 구매"
                            className="w-full text-12 tx_3e52bb h-6 rounded-none bg-gray-100"
                            onClick={() => nonMemberOrder()}
                        />
                        <Button
                            text="회원 구매"
                            className="w-full ml-1 text-12 tx_3e52bb h-6 rounded-none bg-gray-100"
                            onClick={() => memberLogin()}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
